import {
  SR_API_ACTION_LANDLORD_GET,
} from 'api/actionTypes';

export default async function getById({ state, apiClient }, { landlordId }) {
  const landlordIdPath = ['landlords', 'byId', landlordId];
  if (state.get(landlordIdPath)) {
    return state.get(landlordIdPath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_LANDLORD_GET,
    state: state,
    payload: {
      landlordId,
    },
    onSuccess(landlord) {
      state.set(landlordIdPath, landlord);
    },
  });
}
